// Lokala orter för SEO — "husbil [ort]".
// Varje post har UNIK data: avstånd till oss, faktisk lokal info,
// campingplatser, vinterförvaring, vanliga frågor per ort.
// Utöka listan för att skapa fler indexerbara sidor.

export interface OrtData {
  slug: string;
  name: string;
  region: string;
  population: number;
  distanceKm: number;
  driveMin: number;
  focusKeyword: string;
  intro: string;
  campingPlaces: string[];
  stallplatser: string;
  vinter: string;
  handlareIOrt: string;
  varforOss: string[];
  faq: { q: string; a: string }[];
}

export const ORTER: OrtData[] = [
  {
    slug: "boden",
    name: "Boden",
    region: "Norrbotten",
    population: 28000,
    distanceKm: 96,
    driveMin: 68,
    focusKeyword: "husbil Boden",
    intro:
      "Bor du i Boden och letar husbil? Vi på AK Husbil & Fritid ligger drygt en timme bort i Kalix och tar emot kunder från hela Bodenområdet varje vecka. Många väljer oss framför alternativen i Luleå eftersom vi är officiell Rapido-återförsäljare, familjeägda sedan 2004 och har full service på plats.",
    campingPlaces: ["Bodens Camping Björknäs", "Storklinten Ställplats", "Buddbyns Camping"],
    stallplatser:
      "Boden har flera bra ställplatser — Björknäs vid Bodträsket är mest populär med både el, vatten och gästhamn. Storklinten fungerar året runt.",
    vinter:
      "I Bodens klimat är fuktkontroll extra viktig. Vi rekommenderar årlig fuktmätning och att vinterförvara husbilen inomhus mellan november och april. Vi hjälper Bodenkunder med både förvaring och vinterservice.",
    handlareIOrt: "Boden har idag inga större renodlade husbilshandlare — därför kör många Bodenbor till Luleå eller till oss i Kalix.",
    varforOss: [
      "68 minuters bilväg från Boden centrum",
      "Officiell Rapido-återförsäljare — enda i norr",
      "Fukttest, gasol, vinterservice på plats",
      "Vi ordnar transport till Boden mot fast pris",
    ],
    faq: [
      { q: "Finns det husbilshandlare i Boden?", a: "Boden har inga större etablerade husbilshandlare idag. Vi i Kalix (68 min) och några i Luleå är de närmaste alternativen." },
      { q: "Hur långt är det från Boden till Kalix?", a: "96 km, ca 1 timme 8 minuter via E4/väg 356. Många Bodenbor kombinerar besöket med en tur till Haparanda eller Kalix skärgård." },
      { q: "Kan ni serva husbilen om jag bor i Boden?", a: "Ja, vi tar in husbilar från hela Norrbotten. Boka i god tid inför sommar och höstsäsong då trycket är högst." },
    ],
  },
  {
    slug: "pitea",
    name: "Piteå",
    region: "Norrbotten",
    population: 42000,
    distanceKm: 138,
    driveMin: 95,
    focusKeyword: "husbil Piteå",
    intro:
      "Söker du husbil i Piteå eller Piteå kommun? Vi ligger cirka 1 timme 35 minuter norrut i Kalix och möter Piteåkunder både för nya Rapido från fabrik och kontrollerade begagnade husbilar. Piteåbor uppskattar att vi är familjeägda, öppna med priser och kan leverera fordon till Piteå.",
    campingPlaces: ["Piteå Havsbad Camping", "Stenbäckens Camping", "Storforsens Ställplats"],
    stallplatser:
      "Piteå har fina ställplatser vid Piteå Havsbad och centralt vid hamnen. Storforsen (drygt en timme inåt landet) är ett populärt utflyktsmål med bra husbilsparkering.",
    vinter:
      "Piteås kustklimat är milt jämfört med inlandet men luftfuktigheten är hög. Vi rekommenderar fukttest varje vår och vintertäckning eller inomhusförvaring.",
    handlareIOrt: "Piteå har begränsat utbud av renodlade husbilsförsäljare — de flesta åker till Umeå, Luleå eller till oss i Kalix.",
    varforOss: [
      "95 min från Piteå centrum via E4",
      "Officiell Rapido-partner",
      "Personlig hantering — samma säljare från första samtal till leverans",
      "Transport till Piteå ordnas",
    ],
    faq: [
      { q: "Vilka husbilshandlare finns i Piteå?", a: "Piteå har idag ett begränsat utbud lokalt. De närmaste större alternativen är i Luleå (ca 45 min norrut) och vi i Kalix (95 min norrut)." },
      { q: "Kan ni leverera husbil till Piteå?", a: "Ja. Vi transporterar mot fast pris — ring så räknar vi ihop det med köpet." },
      { q: "Har ni service för husbilar från Piteå?", a: "Ja, både verkstad och reservdelar. Boka i god tid — Piteåkunder är stor del av vår servicebok." },
    ],
  },
  {
    slug: "haparanda",
    name: "Haparanda",
    region: "Norrbotten",
    population: 10000,
    distanceKm: 35,
    driveMin: 27,
    focusKeyword: "husbil Haparanda",
    intro:
      "Bor du i Haparanda-Tornio? Då har du landets mest naturliga husbilshandlare på 30 minuters avstånd — vi i Kalix. Många Haparandabor väljer oss för Rapido, för kontrollerade begagnade och för service inför sommar- och skoterhelger.",
    campingPlaces: ["Kukkolaforsen Ställplats", "Haparanda Stadshotell Ställplats", "Seskarö Havsbad"],
    stallplatser:
      "Kukkolaforsen är ett riktigt fint stopp vid Torneälven — el, vatten, sikfiske. Seskarö havsbad är en pärla på sommaren.",
    vinter:
      "Vi har många Haparandakunder som förvarar hos oss november–april. Det blir 30 min bort istället för uppfarten hemma i minus 30.",
    handlareIOrt: "Haparanda har inga husbilshandlare — Kalix är närmaste alternativ.",
    varforOss: [
      "Endast 27 minuters bilväg",
      "Enda Rapido-återförsäljaren norr om Umeå",
      "Vi har verkstad, reservdelar och lager",
      "Familjeägda — du pratar alltid med samma person",
    ],
    faq: [
      { q: "Hur nära är AK Husbil & Fritid från Haparanda?", a: "35 km, ca 27 minuters bilväg via E4." },
      { q: "Finns det husbilshandlare i Haparanda?", a: "Nej, i Haparanda finns idag ingen större husbilshandlare — de flesta åker till oss i Kalix." },
      { q: "Har ni personal som pratar finska?", a: "Vi förstår finska husbilskunder väl och tar emot besökare från Torneåområdet regelbundet." },
    ],
  },
  {
    slug: "overtornea",
    name: "Övertorneå",
    region: "Norrbotten",
    population: 4300,
    distanceKm: 82,
    driveMin: 65,
    focusKeyword: "husbil Övertorneå",
    intro:
      "Övertorneå ligger vid Torneälven med några av landets vackraste husbilsvägar. Vi på AK Husbil & Fritid i Kalix ligger cirka 1 timmes bilväg bort och tar emot kunder från både Övertorneå, Pello och Aavasaksa.",
    campingPlaces: ["Övertorneå Camping", "Aavasaksa Ställplats (FI)"],
    stallplatser:
      "Torneälven har flera fina ställplatser på båda sidor gränsen. Övertorneå camping har el och vatten året runt.",
    vinter: "Här är vintrarna hårda — vi ser många fuktskador på husbilar som stått ute. Vinterförvaring inomhus är en billig försäkring.",
    handlareIOrt: "Övertorneå har ingen husbilshandel — Kalix är enklast (E4 hela vägen).",
    varforOss: ["65 min från Övertorneå centrum", "Officiell Rapido-partner", "Vi kan Torneälvens kunder — många hos oss härifrån"],
    faq: [
      { q: "Vilken väg är bäst till er från Övertorneå?", a: "Följ väg 99 söderut till E4, sedan E4 sista biten till Kalix. Total tid ca 1 timme 5 min." },
      { q: "Servar ni husbilar från Övertorneå?", a: "Absolut, vi har många kunder härifrån. Boka tid — populära perioder fylls fort." },
    ],
  },
  {
    slug: "kiruna",
    name: "Kiruna",
    region: "Norrbotten",
    population: 22000,
    distanceKm: 350,
    driveMin: 240,
    focusKeyword: "husbil Kiruna",
    intro:
      "Kiruna ligger 350 km från oss men vi tar regelbundet emot husbilskunder från både Kiruna, Gällivare och Jokkmokk. Många kombinerar besöket med en helgtur längs kusten. Vi ordnar också transport av husbilar till Kiruna mot fast pris.",
    campingPlaces: ["Camp Ripan", "Kiruna Camping", "Abisko Turiststation Ställplats"],
    stallplatser:
      "Camp Ripan mitt i Kiruna är öppen året runt med el och vatten. Abisko har spektakulär utsikt över Torneträsk.",
    vinter:
      "Kirunas extremkyla ställer höga krav på husbilens värmesystem. Vi kontrollerar Combi/Truma-anläggningar noggrant och rekommenderar dubbla batterier och tilläggsisolering för åretruntbruk.",
    handlareIOrt: "Kiruna har inga stora husbilsförsäljare — närmaste alternativ är Umeå eller vi i Kalix.",
    varforOss: [
      "Vi ordnar transport till Kiruna",
      "Rapidos vintermodeller lämpar sig utmärkt för Norrland",
      "Rådgivning om isolering, värme och batteribank för polarklimat",
    ],
    faq: [
      { q: "Kan jag köpa husbil från Kiruna utan att åka till Kalix?", a: "Ja. Vi kör visning på video, digital kontraktshantering och transporterar husbilen till dig. Många av våra Kirunakunder ser aldrig fordonet innan leverans." },
      { q: "Vilken husbil passar Kirunavinter?", a: "Rapido med Combi 6-värmare eller Truma 6 med dieselvärme, dubbla AGM/litium-batterier och tilläggsisolering på tak. Vi går igenom vad som fungerar." },
    ],
  },
  {
    slug: "gallivare",
    name: "Gällivare",
    region: "Norrbotten",
    population: 18000,
    distanceKm: 275,
    driveMin: 195,
    focusKeyword: "husbil Gällivare",
    intro:
      "Gällivare-Malmberget är hemma för många aktiva husbilsägare — jakt, fiske, skoter, alla i samma fordon. Vi i Kalix är närmaste större Rapido-återförsäljare och tar emot Gällivarekunder både för nybilsköp och service.",
    campingPlaces: ["Gällivare Camping", "Dundret Ställplats"],
    stallplatser: "Gällivare Camping har fina platser vid älven. Dundret ligger vid skidbacken med utsikt över lappländska fjäll.",
    vinter: "Många Gällivarekunder använder husbilen året runt. Vi vet vad som gäller: golvvärme, dieselvärmare, kraftig batteribank.",
    handlareIOrt: "Gällivare har inga större husbilshandlare — Kalix är närmaste seriösa alternativ norrifrån.",
    varforOss: ["Transport ordnas mot fast pris", "Vinterspecifikation Rapido", "Kunniga om nordliga körförhållanden"],
    faq: [
      { q: "Hur långt är det till er från Gällivare?", a: "Ca 275 km, cirka 3 timmar 15 min. Följ väg E10 söderut och sedan E4." },
      { q: "Kan ni leverera till Gällivare?", a: "Ja, transport ordnas. Ring oss så räknar vi." },
    ],
  },
  {
    slug: "arjeplog",
    name: "Arjeplog",
    region: "Norrbotten",
    population: 2700,
    distanceKm: 320,
    driveMin: 240,
    focusKeyword: "husbil Arjeplog",
    intro:
      "Arjeplog är ett paradis för husbilsägare med jakt, fiske och naturupplevelser. Vi tar emot kunder från Arjeplogområdet och ordnar transport av husbilen mot fast pris.",
    campingPlaces: ["Kraja Camping Arjeplog", "Silvervägens Ställplatser"],
    stallplatser: "Kraja Camping vid Hornavan är öppen sommar–höst. Silvervägen har många fina raster längs vägen.",
    vinter: "Arjeplogs vintertester är världsberömda — nästan alla biltillverkare kör här. Husbilen kräver seriös vinterspec.",
    handlareIOrt: "Arjeplog har ingen husbilsförsäljare — Kalix eller Umeå är närmast.",
    varforOss: ["Transport till Arjeplog", "Rapido vinterspec", "Familjär hantering"],
    faq: [
      { q: "Hur tar jag mig till er från Arjeplog?", a: "Väg 95 österut till Boden, sedan E4 nordost till Kalix. Ca 4 timmar." },
      { q: "Servar ni husbilar från Arjeplog?", a: "Ja, både förvaring och service. Kör ner våren efter vintersäsongen." },
    ],
  },
  {
    slug: "umea",
    name: "Umeå",
    region: "Västerbotten",
    population: 132000,
    distanceKm: 340,
    driveMin: 225,
    focusKeyword: "husbil Umeå",
    intro:
      "Umeå har fler husbilshandlare än norra Sverige samlat, så varför skulle en Umeåbo köra till Kalix? Två skäl: vi är enda officiella Rapido-återförsäljaren i norr, och vi är familjeägda med öppen prissättning. Många Umeåbor kör upp för nybilsköp och kombinerar med en helgtur.",
    campingPlaces: ["First Camp Umeå", "Norrfors Ställplats", "Nydala Camping"],
    stallplatser: "First Camp Umeå är stor och centralt belägen. Norrfors är fint för familjer.",
    vinter: "Umeås klimat är milt jämfört med inlandet — men fukttest är fortfarande obligatoriskt varje år.",
    handlareIOrt: "Umeå har flera husbilshandlare — vi konkurrerar främst på Rapido-modellerna och personlig service.",
    varforOss: [
      "Enda officiella Rapido-återförsäljaren norr om Sundsvall",
      "Öppna priser — ingen förhandlingskonst",
      "Vi transporterar husbilen till Umeå kostnadsfritt vid nybilsköp",
    ],
    faq: [
      { q: "Varför köpa i Kalix när jag bor i Umeå?", a: "För Rapido-sortimentet, garantiservice via oss under Rapidos officiella program, och för att vi ofta har bättre priser eftersom vi är en mindre familjeaktör." },
      { q: "Ingår transport?", a: "Vid nybilsköp av Rapido levererar vi till Umeå kostnadsfritt. För begagnat är transport en fast avgift." },
    ],
  },
  {
    slug: "skelleftea",
    name: "Skellefteå",
    region: "Västerbotten",
    population: 76000,
    distanceKm: 200,
    driveMin: 140,
    focusKeyword: "husbil Skellefteå",
    intro:
      "Skellefteå är en av Sveriges snabbast växande städer — med Northvolt och nya arbetstillfällen kommer också en växande husbilsmarknad. Vi ligger 2 timmar 20 minuter norrut i Kalix och möter Skellefteåkunder både för Rapido och kontrollerade begagnade fordon.",
    campingPlaces: ["Skellefteå Camping First Camp", "Byske Havsbad", "Bureå Ställplats"],
    stallplatser: "Byske Havsbad är ett populärt sommarstopp. Skellefteå Camping har el och vatten året runt.",
    vinter: "Skellefteås klimat är milt vid kusten men hårt in mot Malå/Norsjö. Fukttest varje vår är standard.",
    handlareIOrt: "Skellefteå har några husbilshandlare — vi är enda officiella Rapido-återförsäljaren.",
    varforOss: ["140 min via E4", "Rapido — nya från fabrik", "Vinterförvaring för Northvoltarbetare som pendlar"],
    faq: [
      { q: "Hur nära är Skellefteå?", a: "200 km, ca 2 tim 20 min via E4. Rakt körande." },
      { q: "Kan ni sköta bytesaffär från Skellefteå?", a: "Ja, vi tar emot inbytesbilar från hela Norrland — värdering görs via bilder + videosamtal innan besök." },
    ],
  },
  {
    slug: "sundsvall",
    name: "Sundsvall",
    region: "Medelpad",
    population: 100000,
    distanceKm: 620,
    driveMin: 430,
    focusKeyword: "husbil Sundsvall",
    intro:
      "Sundsvall är ett långt hopp från Kalix — men Sundsvallskunder som vill ha Rapido kommer regelbundet upp för nybilsköp eftersom vi är enda officiella återförsäljaren i norra halvan av Sverige. Vi ordnar transport, filminspelning av fordonet och digitalt kontrakt.",
    campingPlaces: ["Sundsvall Camping Fläsian", "Alnö Camping"],
    stallplatser: "Fläsian har havsutsikt och stora platser. Alnö är populärt för familjer.",
    vinter: "Sundsvalls klimat är milt jämfört med Norrland men fukten stor — kontrollera skarvar årligen.",
    handlareIOrt: "Sundsvall har flera husbilshandlare — vi konkurrerar på Rapido-specialisering.",
    varforOss: ["Officiell Rapido-återförsäljare", "Transport till Sundsvall mot fast pris", "Digital köpprocess möjlig"],
    faq: [
      { q: "Är det värt att köra från Sundsvall till Kalix?", a: "För Rapido-modellerna, ja — vi har hela sortimentet och kan bygga specifik konfiguration. För standardbegagnat kan lokalt vara enklare." },
      { q: "Kan hela köpet skötas digitalt?", a: "Ja. Videosamtal, digital signering, transport till dig. Många av våra sydsvenska kunder ser fordonet först vid leverans." },
    ],
  },
  {
    slug: "ostersund",
    name: "Östersund",
    region: "Jämtland",
    population: 51000,
    distanceKm: 780,
    driveMin: 560,
    focusKeyword: "husbil Östersund",
    intro:
      "Östersund ligger långt bort men vi har regelbundet Jämtlandskunder som söker Rapido specifikt. Vi ordnar transport och digital process — köp husbilen från soffan om du vill.",
    campingPlaces: ["Östersunds Camping", "Frösö Ställplats"],
    stallplatser: "Frösö har fint läge vid Storsjön. Vinter/sommaralternativ finns runt fjällkedjan.",
    vinter: "Jämtlands vintrar är hårda i inlandet. Husbil för åretruntbruk behöver dieselvärmare och tilläggsisolering.",
    handlareIOrt: "Östersund har flera husbilshandlare — vi är alternativ specifikt för Rapido.",
    varforOss: ["Rapido-specialister", "Digital köpprocess", "Fast pris för transport"],
    faq: [
      { q: "Ni ligger långt bort — vad är fördelen?", a: "Om du vill ha Rapido är vi enda officiella återförsäljaren i norra halvan. Vi tar hand om hela processen digitalt och transporterar." },
      { q: "Vinterförvaring i norra Norrland?", a: "Frågar mest Jämtlandsbor med sommarhus i Norrland — ja, det går bra, ring för priser." },
    ],
  },
  {
    slug: "stockholm",
    name: "Stockholm",
    region: "Stockholm",
    population: 985000,
    distanceKm: 940,
    driveMin: 660,
    focusKeyword: "husbil Stockholm",
    intro:
      "Stockholm har ett stort utbud husbilshandlare men vi märker att Rapido-intresserade kunder från Stockholm gärna kommer till oss för specifika konfigurationer. Vi hanterar hela processen digitalt: videosamtal, digital signering och transport till dörren.",
    campingPlaces: ["Bredäng Camping Stockholm", "Ängby Camping", "Riksten Ställplats"],
    stallplatser: "Bredäng är stort och centralt. Ängby ligger nära tunnelbanan. Riksten är nyare med moderna faciliteter.",
    vinter: "Stockholms milda vinter är snäll mot husbilar — fukttest på våren räcker för de flesta.",
    handlareIOrt: "Stockholm har många husbilshandlare — vi är alternativ specifikt för Rapido och för dig som vill undvika standardmässiga stormarknader.",
    varforOss: [
      "Rapido-specialisering — full modellkatalog",
      "Digital köpprocess från soffan",
      "Transport till Stockholm ordnas",
      "Familjär hantering utan stress",
    ],
    faq: [
      { q: "Är det värt att köpa i norr när jag bor i Stockholm?", a: "För Rapido specifikt, ofta ja — vi har hela sortimentet och konkurrenskraftiga priser eftersom vi är en familjär aktör." },
      { q: "Hur går det till om jag inte kan komma till Kalix?", a: "Vi filmar fordonet, kör videosamtal, signerar digitalt och kör upp husbilen. Många av våra Stockholmskunder ser fordonet först vid leverans." },
    ],
  },
  {
    slug: "goteborg",
    name: "Göteborg",
    region: "Västra Götaland",
    population: 590000,
    distanceKm: 1150,
    driveMin: 810,
    focusKeyword: "husbil Göteborg",
    intro:
      "Göteborg har starka husbilshandlare men vi tar emot Göteborgskunder som specifikt söker Rapido. Digital process, transport ingår vid nybilsköp av vissa modeller.",
    campingPlaces: ["Askim Strand Camping", "Lisebergsbyn"],
    stallplatser: "Lisebergsbyn är centralt. Askim Strand har havsutsikt.",
    vinter: "Västkustens milda vinter är enklast för husbilar i Sverige. Fukttest räcker.",
    handlareIOrt: "Göteborg har flera stora husbilskedjor — vi är specialistalternativet för Rapido.",
    varforOss: ["Rapido-specialister", "Digital process", "Fast pris transport"],
    faq: [
      { q: "Kan jag köpa Rapido i Göteborg?", a: "Det finns Rapido-återförsäljare i Sverige men vi är den officiella i norra halvan. Vi levererar till Göteborg." },
      { q: "Transport till Göteborg — kostnad?", a: "Beroende på fordon, mellan 8 000–15 000 kr. Ring oss så räknar vi exakt." },
    ],
  },
  {
    slug: "malmo",
    name: "Malmö",
    region: "Skåne",
    population: 350000,
    distanceKm: 1500,
    driveMin: 1050,
    focusKeyword: "husbil Malmö",
    intro:
      "Malmö är långt bort men vi har haft flera skånska Rapido-kunder som köpt digitalt och fått husbilen levererad. Om du är specifikt intresserad av Rapido är det värt ett samtal.",
    campingPlaces: ["First Camp Sibbarp", "Malmö Camping & Ferieby"],
    stallplatser: "Sibbarp har havsutsikt och närhet till centrum. Många ställplatser runt Öresund.",
    vinter: "Skånes milda klimat är enklast för husbilar i Sverige.",
    handlareIOrt: "Malmö/Skåne har stora husbilshandlare — vi är specialistalternativet för Rapido.",
    varforOss: ["Rapido från fabrik", "Digital köp", "Transport till Skåne"],
    faq: [
      { q: "Levererar ni till Malmö?", a: "Ja, vi ordnar transport. Kostnad beror på fordon — räkna 12–18 000 kr." },
      { q: "Behöver jag åka upp?", a: "Nej, hela processen kan skötas digitalt om du inte vill resa 15 timmar." },
    ],
  },
  {
    slug: "vasteras",
    name: "Västerås",
    region: "Västmanland",
    population: 128000,
    distanceKm: 830,
    driveMin: 590,
    focusKeyword: "husbil Västerås",
    intro:
      "Västerås har flera husbilshandlare men Rapido-intresserade kunder kommer regelbundet till oss. Digital process, transport ordnas.",
    campingPlaces: ["Johannisberg Camping", "Skultuna Ställplats"],
    stallplatser: "Johannisberg vid Mälaren är populärt sommartid.",
    vinter: "Mälardalens vintrar är milda — normal fuktkontroll räcker.",
    handlareIOrt: "Västerås har husbilshandlare — vi konkurrerar med Rapido-specialisering.",
    varforOss: ["Rapido från fabrik", "Digital process", "Transport ordnas"],
    faq: [
      { q: "Rapido i Västerås?", a: "Vi levererar och sköter service via samarbetspartners i regionen." },
      { q: "Är det värt att åka upp?", a: "För en full Rapido-visning, ja — vi har hela sortimentet på plats." },
    ],
  },
  {
    slug: "lulea",
    name: "Luleå",
    region: "Norrbotten",
    population: 78000,
    distanceKm: 82,
    driveMin: 60,
    focusKeyword: "husbil Luleå",
    intro:
      "Luleå är största staden i Norrbotten och en av våra viktigaste kundstäder. Vi ligger 60 minuter österut i Kalix och tar emot Luleåkunder både för nya Rapido, kontrollerade begagnade och service. Många Luleåbor väljer oss framför Luleås egna handlare för Rapido-sortimentet, familjär hantering och öppen prissättning.",
    campingPlaces: ["First Camp Luleå Arcus", "Klubbviken Havsbad", "Gültzauudden Ställplats"],
    stallplatser: "Gültzauudden mitt i Luleå är populär sommartid. Arcus har el/vatten året runt. Klubbviken har fina havsplatser.",
    vinter: "Luleås kustklimat är mildare än inlandet men fukten stor. Årlig fuktmätning är standard och vinterförvaring inomhus rekommenderas för husbilar äldre än 5 år.",
    handlareIOrt: "Luleå har några husbilshandlare — vi är enda officiella Rapido-återförsäljaren i regionen.",
    varforOss: [
      "60 min från Luleå centrum",
      "Officiell Rapido-återförsäljare",
      "Familjeägda sedan 2004 — samma personal år efter år",
      "Öppna priser — inga påslag mot Luleåkunder",
    ],
    faq: [
      { q: "Vilken väg är snabbast till er från Luleå?", a: "E4 österut till Kalix — 82 km, ca 1 timme. Rakt och enkelt året runt." },
      { q: "Kan ni hämta min gamla husbil i Luleå vid byte?", a: "Ja. Vi kör värdering på plats i Luleå eller mot digitala bilder och ordnar hämtning kostnadsfritt vid inbyte." },
      { q: "Har ni vinterförvaring för Luleåbor?", a: "Ja, ca 3 200 kr/vinter. Många Luleåkunder förvarar hos oss eftersom uppfarten hemma inte räcker till." },
    ],
  },
  {
    slug: "kalix",
    name: "Kalix",
    region: "Norrbotten",
    population: 16000,
    distanceKm: 0,
    driveMin: 5,
    focusKeyword: "husbil Kalix",
    intro:
      "Vi är Kalix. AK Husbil & Fritid har funnits här sedan 2004 och är kommunens största fritidsfordonshandlare — dessutom enda officiella Rapido-återförsäljaren i norra halvan av Sverige. För dig som bor i Kalix eller Kalix kommun har du landets bäst utrustade husbilsanläggning på 5 minuters bilväg.",
    campingPlaces: ["Kalix Sandskär Camping", "Storön Ställplats", "Grytnäs Ställplats"],
    stallplatser: "Sandskär är sommarens självklara stopp — havsutsikt, badstrand, el/vatten. Storön är småskaligt och lugnt.",
    vinter: "Vi förvarar hundratals husbilar över vintern. Kalix ligger vid kusten så klimatet är mildare än inlandet, men fukttest varje vår är standard.",
    handlareIOrt: "Vi är den etablerade husbilshandlaren i Kalix. Verkstad, reservdelslager, försäljning och förvaring på samma plats.",
    varforOss: [
      "Din lokala husbilshandlare — familjeägda sedan 2004",
      "Största reservdelslagret för Rapido i Norrland",
      "Fullservice-verkstad på plats",
      "Vinterförvaring inomhus",
    ],
    faq: [
      { q: "Var ligger ni exakt i Kalix?", a: "Vid E4 genom Kalix — enkelt att hitta, stor skylt, gott om parkering. Kontakta oss för exakt adress och öppettider." },
      { q: "Har ni utomhusvisning även på vintern?", a: "Ja, hela året. Vi har uppvärmd visningshall för de flesta modeller så du slipper stå ute i kylan." },
    ],
  },
  {
    slug: "arvidsjaur",
    name: "Arvidsjaur",
    region: "Norrbotten",
    population: 4400,
    distanceKm: 260,
    driveMin: 195,
    focusKeyword: "husbil Arvidsjaur",
    intro:
      "Arvidsjaur är hjärtat av Sveriges vintertestindustri och en populär husbilsort året runt. Vi tar emot Arvidsjaurkunder och ordnar transport av husbilar mot fast pris.",
    campingPlaces: ["Camp Gielas", "Prästbergets Camping"],
    stallplatser: "Camp Gielas har öppet året runt med värmestolpar och service.",
    vinter: "Arvidsjaurs extremkyla ställer krav på isolering, batterier och dieselvärmare. Vi känner till kraven — många provbilstestare köper husbil av oss.",
    handlareIOrt: "Arvidsjaur har ingen husbilsförsäljare — Kalix är närmaste större alternativ.",
    varforOss: ["Rapido vinterspec", "Transport ordnas", "Vi kan polarklimat"],
    faq: [
      { q: "Kan Rapido användas i Arvidsjaurs vinter?", a: "Ja, med rätt spec — dieselvärmare, dubbla batterier, kupévärme. Vi bygger konfigurationen med dig." },
      { q: "Hur långt är det?", a: "Ca 260 km, 3 tim 15 min via väg 94 och E4." },
    ],
  },
  {
    slug: "jokkmokk",
    name: "Jokkmokk",
    region: "Norrbotten",
    population: 5000,
    distanceKm: 310,
    driveMin: 225,
    focusKeyword: "husbil Jokkmokk",
    intro:
      "Jokkmokk vid polcirkeln är portal till Sareks och Padjelantas nationalparker — områden där husbilslivet är storslaget. Vi ordnar transport och service för Jokkmokkskunder.",
    campingPlaces: ["Jokkmokk Turistcenter", "Skabram Ställplats"],
    stallplatser: "Turistcentret centralt har el året runt. Skabram är fint sommartid.",
    vinter: "Nordligt läge, hård kyla. Vinterspec-Rapido är rätt val.",
    handlareIOrt: "Jokkmokk har ingen etablerad husbilsförsäljare.",
    varforOss: ["Rapido — Nordanpassade konfigurationer", "Transport ordnas", "Vi kan Sápmi-kunder"],
    faq: [
      { q: "Servar ni husbilar från Jokkmokk?", a: "Ja. Vi bokar in gärna i samband med sommarhalvåret då Norrbottnisk väderlek är stabilast." },
    ],
  },
  {
    slug: "malmberget",
    name: "Malmberget",
    region: "Norrbotten",
    population: 5000,
    distanceKm: 285,
    driveMin: 200,
    focusKeyword: "husbil Malmberget",
    intro:
      "Malmberget/Gällivare är gruvsamhällen med stark husbilstradition. Vi tar emot kunder härifrån för Rapido, service och begagnade.",
    campingPlaces: ["Gällivare Camping", "Dundret"],
    stallplatser: "Dundret vid skidbacken har fantastisk utsikt.",
    vinter: "Många använder husbilen på skoterhelger. Rätt värmesystem är kritiskt.",
    handlareIOrt: "Ingen större husbilshandel — Kalix eller Umeå är närmast.",
    varforOss: ["Rapido med skoter-vänliga konfigurationer", "Transport till Malmberget", "Vinterservice"],
    faq: [
      { q: "Kan husbil användas för skoterhelger?", a: "Ja — vi konfigurerar med skoterluft, dieselvärmare och kraftig batteribank." },
    ],
  },
  {
    slug: "lycksele",
    name: "Lycksele",
    region: "Västerbotten",
    population: 8300,
    distanceKm: 340,
    driveMin: 240,
    focusKeyword: "husbil Lycksele",
    intro:
      "Lycksele i södra Lappland — jakt, fiske, älvspaning. Vi ordnar service och transport för Lyckselekunder.",
    campingPlaces: ["Ansia Resort", "Lycksele Djurpark Ställplats"],
    stallplatser: "Ansia är stort och centralt vid Umeälven.",
    vinter: "Inlandsvinter är hård — vi hjälper med rätt vinterspec.",
    handlareIOrt: "Ingen etablerad husbilshandel i Lycksele.",
    varforOss: ["Rapido-specialister", "Transport ordnas", "Servicebokning för inlandet"],
    faq: [
      { q: "Är det värt att köra från Lycksele?", a: "För Rapido, ja — vi har hela sortimentet på plats. Många kombinerar med en helg vid kusten." },
    ],
  },
  {
    slug: "ornskoldsvik",
    name: "Örnsköldsvik",
    region: "Ångermanland",
    population: 32000,
    distanceKm: 470,
    driveMin: 320,
    focusKeyword: "husbil Örnsköldsvik",
    intro:
      "Örnsköldsvik vid Höga kusten är ett husbilsparadis om somrarna. Vi tar emot Ö-vikskunder och levererar mot fast pris.",
    campingPlaces: ["Snibbens Camping", "Skule Naturum Ställplats", "Höga Kusten Trekantens Camping"],
    stallplatser: "Skule Naturum är UNESCO-världsarv och en av Sveriges finaste husbilsutsikter.",
    vinter: "Kustklimat, milt jämfört med inlandet.",
    handlareIOrt: "Örnsköldsvik har lokala husbilshandlare — vi är alternativet för Rapido.",
    varforOss: ["Rapido-specialister", "Transport ordnas", "Konkurrenskraftiga priser"],
    faq: [
      { q: "Rapido i Ö-vik?", a: "Vi levererar och ordnar service via partners i regionen." },
    ],
  },
  {
    slug: "harnosand",
    name: "Härnösand",
    region: "Ångermanland",
    population: 18000,
    distanceKm: 560,
    driveMin: 385,
    focusKeyword: "husbil Härnösand",
    intro:
      "Härnösand vid Bottenhavet har fina ställplatser och närhet till Höga kusten. Vi tar emot Härnösandskunder digitalt och transporterar.",
    campingPlaces: ["Sälsten Camping", "Härnösand Hamnhällan Ställplats"],
    stallplatser: "Hamnhällan har havsutsikt mitt i staden.",
    vinter: "Kustklimat — normal fuktkontroll räcker.",
    handlareIOrt: "Härnösand har begränsat utbud lokalt.",
    varforOss: ["Rapido från fabrik", "Digital köpprocess", "Transport till Härnösand"],
    faq: [
      { q: "Kör ni ner husbilen?", a: "Ja, mot fast pris. Vanligen 6 000–10 000 kr beroende på fordon." },
    ],
  },
  {
    slug: "uppsala",
    name: "Uppsala",
    region: "Uppland",
    population: 178000,
    distanceKm: 870,
    driveMin: 620,
    focusKeyword: "husbil Uppsala",
    intro:
      "Uppsala har många husbilshandlare men Rapido-intresserade kunder söker sig till oss för specifika konfigurationer och fabriksbeställning. Digital köpprocess, transport till Uppsala.",
    campingPlaces: ["Fyrishov Camping", "Sunnersta Ställplats"],
    stallplatser: "Fyrishov är stort och centralt.",
    vinter: "Mildare Mälardalsvinter — årlig fuktkontroll räcker.",
    handlareIOrt: "Uppsala har flera husbilshandlare — vi är Rapido-specialistalternativet.",
    varforOss: ["Rapido — full modellkatalog", "Digital process", "Transport ordnas"],
    faq: [
      { q: "Rapido i Uppsala?", a: "Vi levererar och sköter service via samarbetspartners i Mellansverige." },
    ],
  },
  {
    slug: "orebro",
    name: "Örebro",
    region: "Närke",
    population: 126000,
    distanceKm: 970,
    driveMin: 690,
    focusKeyword: "husbil Örebro",
    intro:
      "Örebro har växande husbilsintresse. Rapido-kunder från Örebro kommer regelbundet till oss — digital process, transport möjlig.",
    campingPlaces: ["Gustavsviks Resort", "Ånnaboda Ställplats"],
    stallplatser: "Gustavsvik är stort och centralt.",
    vinter: "Mellansverige — normal fuktkontroll.",
    handlareIOrt: "Örebro har husbilshandlare — vi är alternativ för Rapido.",
    varforOss: ["Rapido från fabrik", "Digital köpprocess", "Transport till Örebro"],
    faq: [
      { q: "Kan hela köpet ske digitalt?", a: "Ja. Videosamtal, digital signering, transport." },
    ],
  },
  {
    slug: "linkoping",
    name: "Linköping",
    region: "Östergötland",
    population: 115000,
    distanceKm: 1050,
    driveMin: 745,
    focusKeyword: "husbil Linköping",
    intro:
      "Linköping är stort husbilsmarknad. Rapido-specifika kunder söker oss för fabriksbeställning och unika konfigurationer.",
    campingPlaces: ["Glyttinge Camping", "Roxen Ställplats"],
    stallplatser: "Glyttinge har el och vatten året runt.",
    vinter: "Milt klimat.",
    handlareIOrt: "Linköping har flera husbilshandlare — vi är Rapido-specialisten.",
    varforOss: ["Rapido från fabrik", "Digital köpprocess", "Transport ordnas"],
    faq: [
      { q: "Är det värt att åka upp till Kalix?", a: "För Rapido med konfigurator, ja. Vi har hela sortimentet på plats." },
    ],
  },
  {
    slug: "jonkoping",
    name: "Jönköping",
    region: "Småland",
    population: 100000,
    distanceKm: 1200,
    driveMin: 850,
    focusKeyword: "husbil Jönköping",
    intro:
      "Jönköping vid Vättern har stark husbilstradition. Rapido-kunder från Jönköping ordnar vi digitalt och transporterar.",
    campingPlaces: ["Villa Björkhagens Camping", "Rocksjön Ställplats"],
    stallplatser: "Villa Björkhagen har fint läge vid Vättern.",
    vinter: "Milt klimat.",
    handlareIOrt: "Jönköping har husbilshandlare — vi är Rapido-alternativet.",
    varforOss: ["Rapido från fabrik", "Digital process", "Transport"],
    faq: [
      { q: "Levererar ni till Jönköping?", a: "Ja. Räkna 10 000–14 000 kr transport." },
    ],
  },
  {
    slug: "helsingborg",
    name: "Helsingborg",
    region: "Skåne",
    population: 115000,
    distanceKm: 1470,
    driveMin: 1030,
    focusKeyword: "husbil Helsingborg",
    intro:
      "Helsingborg har flera husbilshandlare men Rapido-intresserade kunder ordnar vi digitalt och levererar.",
    campingPlaces: ["Råå Vallar Resort", "Vikingstrand Camping"],
    stallplatser: "Råå Vallar är populärt sommartid.",
    vinter: "Sveriges mildaste klimat för husbilar.",
    handlareIOrt: "Helsingborg har husbilshandlare — vi är Rapido-specialisten.",
    varforOss: ["Rapido-specialister", "Digital köp", "Transport till Skåne"],
    faq: [
      { q: "Levererar ni till Helsingborg?", a: "Ja, transport ordnas. Ca 13 000–17 000 kr." },
    ],
  },
  {
    slug: "vaxjo",
    name: "Växjö",
    region: "Småland",
    population: 66000,
    distanceKm: 1320,
    driveMin: 940,
    focusKeyword: "husbil Växjö",
    intro:
      "Växjö och Kronobergs län har växande husbilsmarknad. Digital köpprocess för Rapido, transport ingår vissa modeller.",
    campingPlaces: ["Evedals Camping", "Åryds Camping"],
    stallplatser: "Evedal vid Helgasjön är populärt.",
    vinter: "Milt Smålandsklimat.",
    handlareIOrt: "Växjö har lokala husbilshandlare.",
    varforOss: ["Rapido från fabrik", "Digital process", "Transport ordnas"],
    faq: [
      { q: "Rapido i Växjö?", a: "Vi levererar. Service via partners." },
    ],
  },
  {
    slug: "karlstad",
    name: "Karlstad",
    region: "Värmland",
    population: 66000,
    distanceKm: 1080,
    driveMin: 765,
    focusKeyword: "husbil Karlstad",
    intro:
      "Karlstad vid Vänern har stark husbilstradition. Rapido-kunder söker oss för specifika konfigurationer.",
    campingPlaces: ["Skutbergets Camping", "Bomstadbaden"],
    stallplatser: "Skutberget har havsliknande läge vid Vänern.",
    vinter: "Milt klimat.",
    handlareIOrt: "Karlstad har flera husbilshandlare.",
    varforOss: ["Rapido från fabrik", "Digital köp", "Transport ordnas"],
    faq: [
      { q: "Är det värt att köpa i norr?", a: "För Rapido specifikt, ofta ja — vi konfigurerar hela sortimentet." },
    ],
  },
];

export function getOrt(slug: string): OrtData | undefined {
  return ORTER.find((o) => o.slug === slug);
}

export const ORT_SLUGS = ORTER.map((o) => o.slug);
